// extracted by mini-css-extract-plugin
export default {"body":"Text_body__MFWGI","body2":"Text_body2__XtPRn"};